import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { IndicatorLayoutComponentProps } from '../../types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import CountUp from 'react-countup';
import { CellLabel, UiComponentName, useComponentProps, useInViewEffect, useLang } from '@shapeable/ui';
import { Indicator } from '@shapeable/kelp-forest-alliance-types';
import { OCEAN_BLUE_SOFT } from '../../theme';

const cls = classNames('indicator-layout-value');

// -------- Types -------->

// -------- Props -------->

export type IndicatorLayoutValueLabelProps = IndicatorLayoutComponentProps & {
};

const IndicatorLayoutValueLabelDefaultProps: Omit<IndicatorLayoutValueLabelProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.UNIT(1)};
    padding-bottom: ${theme.UNIT(4)};
    ${theme.H_DOT_BG_END('canvas')}
  `,
  landscape: css`
    flex-direction: row;
    align-items: center;
    gap: ${theme.UNIT(2)};
  `,
});

const LabelStyles = breakpoints({
  base: css`
    font-size: 1em;
    color: ${theme.COLOR('mid')};
  `,
  landscape: css`
    flex-shrink: 0;
  `,
});

const ValueAndUnitStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: ${theme.UNIT(1)};
  `,
});

const ValueStyles = breakpoints({
  base: css`
    font-weight: 600;
    font-size: 1.05em;
  `,
});

const UnitStyles = breakpoints({
  base: css`
    color: ${theme.COLOR(OCEAN_BLUE_SOFT)};
    font-weight: 300;
  `,
});


// -------- Components -------->

const My = {
  NAME: 'IndicatorLayoutValueLabel' as UiComponentName,

  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Label: styled(CellLabel)`${LabelStyles}`,
    ValueAndUnit: styled.div`${ValueAndUnitStyles}`,
      Value: styled.span`${ValueStyles}`,
      Unit: styled.span`${UnitStyles}`
};

export const IndicatorLayoutValueLabel: Shapeable.FC<IndicatorLayoutValueLabelProps> = (props) => {
  const componentProps = useComponentProps(My.NAME, IndicatorLayoutValueLabelDefaultProps, props);
  const { className, children, entity } = componentProps;

  const { result } = entity || {};
  const { numericValue, value, indicator } = result || {};
  const { suffixLabel } = (indicator as Indicator) || {};
  const [currentValue, setCurrentValue] = React.useState<number>(0);

  const ref = useInViewEffect(() => { setCurrentValue(numericValue) });
  const isBoolean = value === 'Yes' || value === 'No';
  const t = useLang();

  const showSuffix = !isBoolean && suffixLabel;

  return (
    <My.Container ref={ref} className={cls.name(className)}>
      <My.Label>{t(entity.title)}</My.Label>
      <My.ValueAndUnit>
        <My.Value> {isBoolean ? value : <CountUp separator="," duration={0.5} start={0} end={currentValue} />}</My.Value>
        {showSuffix && <My.Unit> {t(suffixLabel)}</My.Unit>}
      </My.ValueAndUnit>
    </My.Container>
  )
};

IndicatorLayoutValueLabel.cls = cls;